import settings from "./settings"

const isNullOrEmpty = (str) => {
    return !str||!str.trim();
}

const fixFormatting = (arrayOfActions) => {

    const newArray = arrayOfActions.map(actions => {

        const newActions = actions.map(taggedString => {
            let newStr = taggedString
            if (!taggedString.includes("<!--kg-card-begin: html-->")) {
                if (/(?:<em>.+?,)/g.test(taggedString)) {
                    newStr = taggedString.replace(",", ",</em>")
                }
                else if (/(?:.+?<\/em>)/g.test(taggedString)) {
                    if (!taggedString.includes("<em>")) {
                        newStr = `<em>${taggedString}`
                    }
                }
                if (/(?:<strong>.+?,)/g.test(taggedString)) {
                    newStr = taggedString.replace(",", ",</strong>")
                }
                else if (/(?:.+?<\/strong>)/g.test(taggedString)) {
                    if (!taggedString.includes("<strong>")) {
                        newStr = `<strong>${taggedString}`
                    }
                }
                if (taggedString !== newStr) {
                    //console.log(`Before: "${taggedString}", After: "${newStr}"`)
                }
            }

            return newStr
        })
        return newActions
    })
    return newArray
}

const cleanStrings = (array) => {
    const cleanedStrings = array.map(taggedString => {
        let string = taggedString
        if (taggedString) {
            string = taggedString
                .replace(/[\n\r]+/g, '')
                .replace("<!--kg-card-end: html-->", "")
            if (string.includes("<!--kg-card-begin: markdown-->")) {
                return
            }
            if (!isNullOrEmpty(string)) {
                return string
            }
        }

    })

    return cleanedStrings.filter(Boolean)
}

const extractAndCleanParagraphStrings = (html) => {
    //extract the string within paragraphs
    const paragraphSplitter = /(?:<p>)(.+?)(?:<\/p>)/g
    const paragraphStrings = html.split(paragraphSplitter)
    return cleanStrings(paragraphStrings)
}

const addPauseAfterCommas = (strings) => {
    const stringsWithCommaPauses = strings.map(str => {
        let newStr = str
        if (!str.includes("kg-card")) {
            newStr = str.replace(/,/g, ", <code>.pauseFor(comma)</code>")
        }
        return newStr
    })
    return stringsWithCommaPauses
}

const splitStringsIntoActions = (strings) => {
    let finishedStringsArray = strings.map(str => {
        //Find special tags and split up the strings
        const findTags = /(<code>.pauseFor\(.+?\)<\/code>)|(<code>.changeDelay\(.+?\)<\/code>)|(<code>.deleteChars\(.+?\)<\/code>)|(<code>.changeDeleteSpeed\(.+?\)<\/code>)|(<code>.openContents\(.+?\)<\/code>)/g
        const extractTags = str.split(findTags)
        const cleanedStrings = cleanStrings(extractTags)

        return cleanedStrings
    })
    return finishedStringsArray
}

const replaceInputPlaceholders = (inputData, html) => {
    let newHTML = html;
    if (inputData.name) {
        newHTML = newHTML.replace(/\[NAME\]/g, inputData.name)
    }
    if (inputData.email) {
        newHTML = newHTML.replace(/\[EMAIL\]/g, inputData.email)
    }
    return newHTML
}

const processHtml = ({html, isResponse, inputData}) => {

    //const htmlWithPlaceholders = replaceInputPlaceholders(inputData, html)

    //Remove the <P> tags and clean the strings
    const cleanedParagraphStrings = extractAndCleanParagraphStrings(html)

    //Remove the first paragraph containing the chunkID
    if (!isResponse) {
        cleanedParagraphStrings.shift()
    }

    //Add a .pauseFor tag after commas
    const stringsWithCommaPauses = addPauseAfterCommas(cleanedParagraphStrings)

    //Split the strings into an array of separate actions for the typewriter to process
    const actionStrings = splitStringsIntoActions(stringsWithCommaPauses)

    //Fix formatting caused by the pause tag
    const cleanedArrayOfActions = fixFormatting(actionStrings)

    //Return the processed array of actions, ready to add to typewriter
    return cleanedArrayOfActions
}

export default processHtml
